/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SitePlanControllerService {
    /**
     * @param formData Request body for multipart/form-data based file upload
     * @param propertyId
     * @returns any Image upload response
     * @throws ApiError
     */
    public static sitePlanControllerUploadSitePlanImage(
        formData: {
            file?: Blob;
        },
        propertyId?: string,
    ): CancelablePromise<{
        message?: string;
        sitePlanImageUrl?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/site-plans/upload',
            query: {
                'propertyId': propertyId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param propertyId
     * @returns any Reset site plan
     * @throws ApiError
     */
    public static sitePlanControllerResetSitePlan(
        propertyId: string,
    ): CancelablePromise<{
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/site-plans/{propertyId}/reset',
            path: {
                'propertyId': propertyId,
            },
        });
    }
    /**
     * @param propertyId
     * @param requestBody Rotation degree update
     * @returns any Update rotation degree of site plan
     * @throws ApiError
     */
    public static sitePlanControllerUpdateRotation(
        propertyId: string,
        requestBody: {
            rotationDegree: number;
        },
    ): CancelablePromise<{
        message?: string;
        rotationDegree?: number;
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/site-plans/{propertyId}/rotation',
            path: {
                'propertyId': propertyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param propertyId
     * @returns any Fetch site plan details
     * @throws ApiError
     */
    public static sitePlanControllerGetSitePlan(
        propertyId: string,
    ): CancelablePromise<{
        sitePlanImageUrl?: string;
        rotationDegree?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/site-plans/{propertyId}',
            path: {
                'propertyId': propertyId,
            },
        });
    }
}
